import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();
export function useTheme() { return useContext(ThemeContext); }

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('gorTheme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('gorTheme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
